module.exports = __webpack_public_path__ + "img/processing_black.45219337.svg";